import React, { useState } from "react";
import ComercialGanhos from "../componentes/ComercialGanhos/ComercialGanhos";

const BacklogVendas =  () => {
    const [showAlert, setShowAlert] = useState(true);

    const handleRedirect = () => {
        window.location.href = "https://sic.conticonsultoria.cloud/";
    };

    return(
        <div className="flex w-full Home-content px-10">
            {showAlert && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "#fff",
                        padding: "2rem",
                        borderRadius: "8px",
                        maxWidth: "400px",
                        textAlign: "center"
                    }}>
                        <h2>Backlog Movido!</h2>
                        <p>
                            O Backlog foi movido para a versão 1 do SIC.<br />
                            Clique no botão abaixo para acessar.<br /><br />
                            Todo o restante do fluxo permanece na versão inicial (Beta).
                        </p>
                        <button
                            onClick={handleRedirect}
                            style={{
                                marginTop: "1rem",
                                padding: "0.5rem 1.5rem",
                                background: "#007bff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer"
                            }}
                        >
                            Seguir para o novo Backlog
                        </button>
                        <br />
                        <button
                            onClick={() => setShowAlert(false)}
                            style={{
                                marginTop: "0.5rem",
                                background: "transparent",
                                color: "#007bff",
                                border: "none",
                                cursor: "pointer",
                                textDecoration: "underline"
                            }}
                        >
                            Permanecer aqui
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default BacklogVendas